<template>
  <div class="admin-summary-box">
    <div class="admin-summary-item">
      <div class="admin-summary-overlay primary"></div>
      <div class="admin-summary-content">
        <div>
          <p class="admin-summary-title primary">결제전</p>
          <p class="admin-summary-value">
            {{ beforeDepositCount.toLocaleString() }} 개
          </p>
        </div>
        <span class="material-icons-round">report_problem</span>
      </div>
    </div>
    <div class="admin-summary-item">
      <div class="admin-summary-overlay primary"></div>
      <div class="admin-summary-content">
        <div>
          <p class="admin-summary-title primary">결제완료</p>
          <p class="admin-summary-value">
            {{ paymentCompletedCount.toLocaleString() }} 개
          </p>
        </div>
        <span class="material-icons-round">report_problem</span>
      </div>
    </div>
    <div class="admin-summary-item">
      <div class="admin-summary-overlay primary"></div>
      <div class="admin-summary-content">
        <div>
          <p class="admin-summary-title primary">상품 준비중</p>
          <p class="admin-summary-value">
            {{ preparingProductCount.toLocaleString() }} 개
          </p>
        </div>
        <span class="material-icons-round">report_problem</span>
      </div>
    </div>
    <div class="admin-summary-item">
      <div class="admin-summary-overlay primary"></div>
      <div class="admin-summary-content">
        <div>
          <p class="admin-summary-title primary">배송 준비중</p>
          <p class="admin-summary-value">
            {{ preparingDeliveryCount.toLocaleString() }} 개
          </p>
        </div>
        <span class="material-icons-round">report_problem</span>
      </div>
    </div>
    <div class="admin-summary-item">
      <div class="admin-summary-overlay green"></div>
      <div class="admin-summary-content">
        <div>
          <p class="admin-summary-title green">배송 중</p>
          <p class="admin-summary-value">
            {{ shippingProgressCount.toLocaleString() }} 개
          </p>
        </div>
        <span class="material-icons-round">report_problem</span>
      </div>
    </div>
    <div class="admin-summary-item">
      <div class="admin-summary-overlay yellow"></div>
      <div class="admin-summary-content">
        <div>
          <p class="admin-summary-title yellow">배송완료</p>
          <p class="admin-summary-value">
            {{ deliveryCompleted.toLocaleString() }} 개
          </p>
        </div>
        <span class="material-icons-round">report_problem</span>
      </div>
    </div>
    <div class="admin-summary-item">
      <div class="admin-summary-overlay red"></div>
      <div class="admin-summary-content">
        <div>
          <p class="admin-summary-title red">취소 요청</p>
          <p class="admin-summary-value">
            {{ requestCancelCount.toLocaleString() }} 개
          </p>
        </div>
        <span class="material-icons-round">report_problem</span>
      </div>
    </div>
    <div class="admin-summary-item">
      <div class="admin-summary-overlay red"></div>
      <div class="admin-summary-content">
        <div>
          <p class="admin-summary-title red">교환 요청</p>
          <p class="admin-summary-value">
            {{ requestExchangeCount.toLocaleString() }} 개
          </p>
        </div>
        <span class="material-icons-round">report_problem</span>
      </div>
    </div>
    <div class="admin-summary-item">
      <div class="admin-summary-overlay red"></div>
      <div class="admin-summary-content">
        <div>
          <p class="admin-summary-title red">반품 요청</p>
          <p class="admin-summary-value">
            {{ requestReturnCount.toLocaleString() }} 개
          </p>
        </div>
        <span class="material-icons-round">report_problem</span>
      </div>
    </div>
    <div class="admin-summary-item">
      <div class="admin-summary-overlay info"></div>
      <div class="admin-summary-content">
        <div>
          <p class="admin-summary-title info">취소 처리중</p>
          <p class="admin-summary-value">
            {{ processingCancelCount.toLocaleString() }} 개
          </p>
        </div>
        <span class="material-icons-round">report_problem</span>
      </div>
    </div>
    <div class="admin-summary-item">
      <div class="admin-summary-overlay info"></div>
      <div class="admin-summary-content">
        <div>
          <p class="admin-summary-title info">교환 처리중</p>
          <p class="admin-summary-value">
            {{ processingExchangeCount.toLocaleString() }} 개
          </p>
        </div>
        <span class="material-icons-round">report_problem</span>
      </div>
    </div>
    <div class="admin-summary-item">
      <div class="admin-summary-overlay info"></div>
      <div class="admin-summary-content">
        <div>
          <p class="admin-summary-title info">반품 처리중</p>
          <p class="admin-summary-value">
            {{ processingReturnCount.toLocaleString() }} 개
          </p>
        </div>
        <span class="material-icons-round">report_problem</span>
      </div>
    </div>
    <div class="admin-summary-item">
      <div class="admin-summary-overlay secondary"></div>
      <div class="admin-summary-content">
        <div>
          <p class="admin-summary-title secondary">취소 보류</p>
          <p class="admin-summary-value">
            {{ holdCancelCount.toLocaleString() }} 개
          </p>
        </div>
        <span class="material-icons-round">report_problem</span>
      </div>
    </div>
    <div class="admin-summary-item">
      <div class="admin-summary-overlay secondary"></div>
      <div class="admin-summary-content">
        <div>
          <p class="admin-summary-title secondary">교환 보류</p>
          <p class="admin-summary-value">
            {{ holdExchangeCount.toLocaleString() }} 개
          </p>
        </div>
        <span class="material-icons-round">report_problem</span>
      </div>
    </div>
    <div class="admin-summary-item">
      <div class="admin-summary-overlay secondary"></div>
      <div class="admin-summary-content">
        <div>
          <p class="admin-summary-title secondary">반품 보류</p>
          <p class="admin-summary-value">
            {{ holdReturnCount.toLocaleString() }} 개
          </p>
        </div>
        <span class="material-icons-round">report_problem</span>
      </div>
    </div>
    <div class="admin-summary-item">
      <div class="admin-summary-overlay green"></div>
      <div class="admin-summary-content">
        <div>
          <p class="admin-summary-title green">취소 승인</p>
          <p class="admin-summary-value">
            {{ approvedCancelCount.toLocaleString() }} 개
          </p>
        </div>
        <span class="material-icons-round">report_problem</span>
      </div>
    </div>
    <div class="admin-summary-item">
      <div class="admin-summary-overlay green"></div>
      <div class="admin-summary-content">
        <div>
          <p class="admin-summary-title green">교환 승인</p>
          <p class="admin-summary-value">
            {{ approvedExchangeCount.toLocaleString() }} 개
          </p>
        </div>
        <span class="material-icons-round">report_problem</span>
      </div>
    </div>
    <div class="admin-summary-item">
      <div class="admin-summary-overlay green"></div>
      <div class="admin-summary-content">
        <div>
          <p class="admin-summary-title green">반품 승인</p>
          <p class="admin-summary-value">
            {{ approvedReturnCount.toLocaleString() }} 개
          </p>
        </div>
        <span class="material-icons-round">report_problem</span>
      </div>
    </div>
  </div>
  <div class="admin-sales-box">
    <div class="admin-sales-header">
      <h3>일자별 매출</h3>
    </div>
    <hr />
    <div class="admin-sales-body">
      <Line :data="salesChartData" :options="salesChartOptions" />
    </div>
  </div>
  <div class="admin-calculate-box">
    <div class="admin-calculate-header">
      <h3>매출 / 정산</h3>
    </div>
    <hr />
    <div class="admin-calculate-body">
      <div>
        <p>오늘 매출</p>
        <p>1,234,567 원</p>
      </div>
      <div>
        <p>이번 주 매출</p>
        <p>1,234,567 원</p>
      </div>
      <div>
        <p>이번 달 매출</p>
        <p>1,234,567 원</p>
      </div>
      <div>
        <p>이번 달 정산 예정액</p>
        <p>1,234,567 원</p>
      </div>
      <div>
        <p>이번 달 차감 예정액</p>
        <p>1,234,567 원</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { Line } from "vue-chartjs";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Colors,
} from "chart.js";
import { onMounted, ref } from "vue";
import { collection, getDocs } from "firebase/firestore";
import { db } from "@/lib/firebase";
import { useBusyLock } from "@/lib/useBusyLock";

const { runLocked } = useBusyLock();

const beforeDepositCount = ref(0);
const paymentCompletedCount = ref(0);
const preparingProductCount = ref(0);
const preparingDeliveryCount = ref(0);
const shippingProgressCount = ref(0);
const deliveryCompleted = ref(0);

const requestCancelCount = ref(0);
const processingCancelCount = ref(0);
const holdCancelCount = ref(0);
const approvedCancelCount = ref(0);

const requestExchangeCount = ref(0);
const processingExchangeCount = ref(0);
const holdExchangeCount = ref(0);
const approvedExchangeCount = ref(0);

const requestReturnCount = ref(0);
const processingReturnCount = ref(0);
const holdReturnCount = ref(0);
const approvedReturnCount = ref(0);

const salesChartOptions = {
  responsive: true,
};
const salesChartData = {
  labels: ["January", "February", "March", "April", "May", "June", "July"],
  datasets: [
    {
      data: [1327000, 1235678, 800000, 430000, 1640000, 340000, 240000],
    },
  ],
};

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Colors
);

onMounted(() => {
  runLocked(async () => {
    const snap = await getDocs(collection(db, "productOrder"));
    const orders = snap.docs.map((docSnap) => docSnap.data());

    // 초기화
    beforeDepositCount.value = 0;
    paymentCompletedCount.value = 0;
    preparingProductCount.value = 0;
    preparingDeliveryCount.value = 0;
    shippingProgressCount.value = 0;
    deliveryCompleted.value = 0;

    requestCancelCount.value = 0;
    processingCancelCount.value = 0;
    holdCancelCount.value = 0;
    approvedCancelCount.value = 0;

    requestExchangeCount.value = 0;
    processingExchangeCount.value = 0;
    holdExchangeCount.value = 0;
    approvedExchangeCount.value = 0;

    requestReturnCount.value = 0;
    processingReturnCount.value = 0;
    holdReturnCount.value = 0;
    approvedReturnCount.value = 0;

    // 1회 순회로 집계
    for (const order of orders) {
      const status = order.status || "";
      const claimStatus = order.claimStatus || "";

      // 일반 주문 상태
      if (status === "BEFORE_PAYMENT") beforeDepositCount.value++;
      else if (status === "PAYMENT_COMPLETED") paymentCompletedCount.value++;
      else if (status === "PREPARING_PRODUCT") preparingProductCount.value++;
      else if (status === "PREPARING_DELIVERY") preparingDeliveryCount.value++;
      else if (status === "SHIPPING_PROGRESS") shippingProgressCount.value++;
      else if (status === "DELIVERY_COMPLETED") deliveryCompleted.value++;

      // 클레임 상태
      if (status === "CANCELLED") {
        if (claimStatus === "REQUEST_CANCEL") requestCancelCount.value++;
        else if (claimStatus === "PROCESSING_CANCEL")
          processingCancelCount.value++;
        else if (claimStatus === "HOLD_CANCEL") holdCancelCount.value++;
        else if (claimStatus === "APPROVED_CANCEL") approvedCancelCount.value++;
      }

      if (status === "EXCHANGE") {
        if (claimStatus === "REQUEST_EXCHANGE") requestExchangeCount.value++;
        else if (claimStatus === "PROCESSING_EXCHANGE")
          processingExchangeCount.value++;
        else if (claimStatus === "HOLD_EXCHANGE") holdExchangeCount.value++;
        else if (claimStatus === "APPROVED_EXCHANGE")
          approvedExchangeCount.value++;
      }

      if (status === "RETURNED") {
        if (claimStatus === "REQUEST_RETURN") requestReturnCount.value++;
        else if (claimStatus === "PROCESSING_RETURN")
          processingReturnCount.value++;
        else if (claimStatus === "HOLD_RETURN") holdReturnCount.value++;
        else if (claimStatus === "APPROVED_RETURN") approvedReturnCount.value++;
      }
    }
  }).catch((error) => {
    console.error("주문 통계 로딩 실패:", error);
    alert("주문 통계를 불러오는 중 오류가 발생했습니다.");
  });
});
</script>

<style lang="scss" scoped>
.admin-summary-box {
  margin-top: 36px;
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  > .admin-summary-item {
    height: 120px;
    width: 304px;
    position: relative;
    box-shadow: 8px 8px 16px rgba(0, 0, 0, 0.2);
    border-radius: 8px;

    > .admin-summary-overlay {
      width: 100%;
      height: 100%;
      position: absolute;
      border-radius: 8px;

      &.primary {
        background-color: #007bff;
      }

      &.green {
        background-color: #28a745;
      }

      &.yellow {
        background-color: #ffc107;
      }

      &.red {
        background-color: #dc3545;
      }

      &.secondary {
        background-color: #333;
      }

      &.info {
        background-color: #17a2b8;
      }
    }

    > .admin-summary-content {
      background-color: #fff;
      position: absolute;
      width: calc(100% - 4px);
      right: 0;
      height: 100%;
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 16px;
      gap: 8px;

      > div {
        > .admin-summary-title {
          font-weight: 700;
          font-size: 24px;
        }

        > .admin-summary-value {
          margin-top: 8px;
          font-size: 18px;
        }
      }

      > span {
        font-size: 64px;
        color: rgba(0, 0, 0, 0.25);
      }

      .primary {
        color: #007bff;
      }

      .green {
        color: #28a745;
      }

      .yellow {
        color: #ffc107;
      }

      .red {
        color: #dc3545;
      }

      .secondary {
        color: #333;
      }

      .info {
        color: #17a2b8;
      }
    }
  }
}

.admin-sales-box,
.admin-calculate-box {
  border-radius: 8px;
  margin-top: 36px;
  box-shadow: 8px 8px 16px rgba(0, 0, 0, 0.25);

  > .admin-sales-header,
  .admin-calculate-header {
    padding: 16px 24px;

    > h3 {
      font-weight: 700;
      font-size: 18px;
      color: #dc3545;
    }
  }

  > hr {
    border: none;
    border-top: solid rgba(0, 0, 0, 0.15);
  }

  > .admin-sales-body,
  .admin-calculate-body {
    padding: 16px 24px;

    > div {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 36px;
    }
  }
}
</style>
